import "../index.css";
import "./App.css";
import CaptchaPage from "../pages/CaptchaPage/CaptchaPage";

function App() {
  return <CaptchaPage />;
}

export default App;
